import { ConversationFileTypeEnum } from './enums';
import {
	VideoExtensionEnum,
	ImageExtensionEnum,
	AttachmentExtensionEnum,
} from '../lib/enums';
import {
	iOSMajorVersion,
	isHuaweiBrowser,
	isQQBrowser,
} from './detect-utils';

const {
	IMAGE,
	VIDEO,
	ATTACHMENT,
} = ConversationFileTypeEnum;
const videoExtensions = Object.values(VideoExtensionEnum);
const imageExtensions = Object.values(ImageExtensionEnum);
const attachmentExtensions = Object.values(AttachmentExtensionEnum);

export const getUploadFileSrc = async (file = {}) => {
	let src = file.url;

	if (!src) {
		src = await new Promise(resolve => {
			const reader = new FileReader();

			reader.readAsDataURL(file);
			reader.onload = () => resolve(reader.result);
		});
	}

	return src;
};
export const acceptExtensions = [
	...videoExtensions,
	...imageExtensions,
	...attachmentExtensions,
];
export function getFileType(name = '') {
	const splitName = name.split('.');
	const type = splitName[splitName.length - 1].toLowerCase();

	if (videoExtensions.includes(type)) {
		return VIDEO;
	}

	if (imageExtensions.includes(type)) {
		return IMAGE;
	}

	if (attachmentExtensions.includes(type)) {
		return ATTACHMENT;
	}

	return null;
}

const detectSpecificBrowserOrDevice = () => {
	if (iOSMajorVersion < 15) {
		return true;
	}

	if (isHuaweiBrowser || isQQBrowser) {
		return true;
	}

	return false;
};

export const getAcceptFileType = () => {
	const isSpecificBrowserOrDevice = detectSpecificBrowserOrDevice();

	if (isSpecificBrowserOrDevice) {
		return acceptExtensions
			.map(type => `.${type}`)
			.join(',');
	}

	return '*/*';
};

const _convertBlobToPng = blob => {
	return new Promise((resolve, reject) => {
		const img = new Image();
		const canvas = document.createElement('canvas');
		const ctx = canvas.getContext('2d');

		img.onload = () => {
			canvas.width = img.width;
			canvas.height = img.height;
			ctx.drawImage(img, 0, 0);
			canvas.toBlob(resolve, 'image/png');
		};

		img.onerror = err => {
			reject(err);
		};

		img.src = URL.createObjectURL(blob);
	});
};

export const copyImg = ({
	url,
	onSuccess = () => {},
	onError = () => {},
}) => {
	fetch(url, { cache: 'no-cache' })
		.then(response => response.blob())
		.then(blob => {
			const mimeType = blob.type;

			if (mimeType === 'image/png') {
				return blob;
			}

			if (mimeType === 'image/jpeg') {
				return _convertBlobToPng(blob);
			}

			throw new Error('Not support image type');
		})
		.then(pngBlob => {
			// eslint-disable-next-line no-undef
			const item = new ClipboardItem({ 'image/png': pngBlob });

			navigator.clipboard.write([item])
				.then(onSuccess)
				.catch(onError);
		})
		.catch(onError);
};

export const getUnexpiredShareUrl = share => {
	const { url, expiredAt } = share || {};

	if (!url || !expiredAt) {
		return '';
	}

	return new Date(expiredAt) > new Date() ? url : '';
};

export function downloadBlob(blob, fileName = 'download') {
	const url = URL.createObjectURL(blob);
	const anchorElement = document.createElement('a');

	anchorElement.href = url;
	anchorElement.download = fileName;
	anchorElement.style.display = 'none';
	document.body.appendChild(anchorElement);
	anchorElement.click();
	document.body.removeChild(anchorElement);
	URL.revokeObjectURL(url);
}
